export const ORDER_ITEMS_GET_LIST = "/orderitems";
export const ORDER_ITEMS_GET_ACTIVE = "/orderitems/active";
export const ORDER_ITEMS_CHECK = "/orderitems/check";
export const PREDICTION = "/orderitems/prediction";